import { render } from "./RankingList.vue?vue&type=template&id=0162e3af&scoped=true"
import script from "./RankingList.vue?vue&type=script&lang=js"
export * from "./RankingList.vue?vue&type=script&lang=js"

import "./RankingList.vue?vue&type=style&index=0&id=0162e3af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0162e3af"]])

export default __exports__